import { CheckResult } from '../types';

export async function screenShareCheck(): Promise<CheckResult> {
  const timestamp = new Date().toISOString();

  if (!navigator.mediaDevices?.getDisplayMedia) {
    return {
      checkId: 'screen_share',
      checkName: 'Compartilhamento de Tela',
      status: 'failed',
      details:
        'Seu navegador não suporta compartilhamento de tela. Use o Google Chrome para continuar.',
      timestamp,
    };
  }

  let stream: MediaStream | null = null;

  try {
    stream = await navigator.mediaDevices.getDisplayMedia({
      video: { displaySurface: 'monitor' } as MediaTrackConstraints,
    });

    const videoTrack = stream.getVideoTracks()[0];
    if (!videoTrack) {
      stream.getTracks().forEach(track => track.stop());
      return {
        checkId: 'screen_share',
        checkName: 'Compartilhamento de Tela',
        status: 'failed',
        details:
          'Nenhuma faixa de vídeo obtida no compartilhamento. Tente novamente.',
        timestamp,
      };
    }

    const settings = videoTrack.getSettings();
    const displaySurface = (settings as Record<string, unknown>)
      .displaySurface as string | undefined;

    if (displaySurface !== 'monitor') {
      stream.getTracks().forEach(track => track.stop());
      return {
        checkId: 'screen_share',
        checkName: 'Compartilhamento de Tela',
        status: 'failed',
        details:
          'Você precisa compartilhar a tela inteira (não apenas uma aba ou janela). Tente novamente e selecione "Tela inteira".',
        timestamp,
        metadata: { displaySurface: displaySurface ?? 'unknown' },
      };
    }

    return {
      checkId: 'screen_share',
      checkName: 'Compartilhamento de Tela',
      status: 'passed',
      details: 'Compartilhamento de tela inteira ativo.',
      timestamp,
      metadata: {
        displaySurface,
        // The stream is passed via a non-serializable ref so it never enters
        // Redux or localStorage.  Consumers read it from `_streamRef`.
      },
      _streamRef: stream,
    };
  } catch (error) {
    stream?.getTracks().forEach(track => track.stop());

    const domError = error as DOMException;
    if (
      domError?.name === 'NotAllowedError' ||
      domError?.name === 'AbortError'
    ) {
      return {
        checkId: 'screen_share',
        checkName: 'Compartilhamento de Tela',
        status: 'failed',
        details:
          'Permissão de compartilhamento de tela negada. Autorize o compartilhamento e tente novamente.',
        timestamp,
        metadata: { errorName: domError.name },
      };
    }

    return {
      checkId: 'screen_share',
      checkName: 'Compartilhamento de Tela',
      status: 'failed',
      details:
        'Erro ao iniciar o compartilhamento de tela. Verifique as permissões do navegador e tente novamente.',
      timestamp,
      metadata: { errorName: domError?.name ?? 'unknown' },
    };
  }
}
